import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { lighten } from 'polished'

import Alert from '../../Atoms/Alert'
import Hoverable from '../../Atoms/Hover'
import InlineError from '../../Atoms/InlineError'
import { Text } from '../../Atoms/Typography'
import Touchable from '../../Atoms/Touchable'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'

import theme from '../../../styles/theme'

const Options = styled(View)`
  margin-top: ${2 * theme.gutterUnit}px;
`

const Option = styled(Touchable)`
  border: 1px solid ${props => props.selected ? theme.colours.primary : theme.colours.black};
  margin-bottom: ${theme.gutterUnit}px;
  padding: ${theme.gutterUnit}px;
  ${props => props.selected ? `background-color: ${theme.colours.primary}` : ''}
  border-radius: 5px;
`

const SpinnerContainer = styled(View)`
  height: 100px;
`

export default class OptionsAlert extends PureComponent {
    renderSpinner = () => {
      return (
        <SpinnerContainer>
          <CenteredSpinner />
        </SpinnerContainer>
      )
    }

    render () {
      const {
        visible,
        onCancel,
        onConfirm,
        confirmInProgress = false,

        error,
        isLoading,
        title,
        emptyTitle,
        emptyText,

        options
      } = this.props

      return (
        <Alert visible={visible} onCancel={(options.length) ? onCancel : undefined} onConfirm={(options.length) ? onConfirm : onCancel} confirmInProgress={confirmInProgress}>
          {error && <InlineError message={error} />}
          {!!options.length && <Text bold>{title}</Text>}
          {!options.length && !isLoading && <Text bold>{emptyTitle}</Text>}
          {isLoading && this.renderSpinner()}
          <Options>
            {!!options.length && options.map((o) => {
              return (
                <Hoverable key={o.value}>
                  {(isHovered) => (
                    <Option
                      data-test={`option-${o.value}`}
                      key={o.value}
                      disabled={o.disabled ? o.disabled : false}
                      onPress={o.handlePress}
                      selected={o.selected}
                      style={[isHovered && !o.selected && {
                        backgroundColor: `${lighten(0.3, theme.colours.primary)}`,
                        borderColor: `${lighten(0.3, theme.colours.primary)}`,
                        borderWidth: 1
                      }]}
                    >
                      <Text white={o.selected || isHovered}>{o.name}</Text>
                    </Option>
                  )}
                </Hoverable>
              )
            })}
            {!options.length && !isLoading && <Text size='s'>{emptyText}</Text>}
          </Options>
        </Alert>
      )
    }
}
